import i18n from "i18n/i18n";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as RoundedbackSvg } from "assets/Svgs/RoundedBack.svg";
import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getReminderItems, reminders, repetions } from "utils/helper";
import GenericAttachment from "components/GenericAttachments";
import { useBoundStore } from "store/store";
import dayjs from "dayjs";

function EditMaintenance(props: any) {

  const lang:any = useBoundStore((state) => state.lang);

  const location = useLocation();
  const maintenancetask = location?.state?.maintenancetask;
  const edit = location?.state?.edit;

  const getAllMaintenanceCategories = useBoundStore(
    (state) => state.getAllMaintenanceCategories
  );

  useEffect(() => {
    
    getAllMaintenanceCategories();
  }, []);

  const subscribedEquipments = useBoundStore(
    (state) => state.subscribedEquipments
  ) as any;

  const maintenanceCategories: any = useBoundStore(
    (state) => state.maintenanceCategories
  );
  const StandardMaintenanceCategories = Array.isArray(maintenanceCategories)
    ? maintenanceCategories.map((item) => ({
        title: item.maintenancecategory.name,
        value: item.maintenancecategory.nodeid,
        colorcode: item.maintenancecategory.colorcode,
      }))
    : [];

  const [dropdownMaintenanceCategory, setDropdownMaintenanceCategory] =
    useState(StandardMaintenanceCategories);

  const formatDate = (datee: any) => {
    const date = new Date(datee);

    // Get year, month, and day
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const day = date.getDate();

    // Format month and day to always be two digits
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    // Combine into final formatted string
    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    return formattedDate;
  };

  const [category, setcategory] = useState<any>("");
  const [title, settitle] = useState("");
  const [description, setDescription] = useState("");
  const [maintenanceDate, setMaintenanceDate] = useState<any>();
  const [maintenanceRepetition, setmaintenanceRepetition] = useState<any>("");
  const [maintenanceReminder, setmaintenanceReminder] = useState<any>("");
  const [image_data, set_image_data] = useState([]);
  const [video_data, set_video_data] = useState([]);
  const [docs_data, set_docs_data] = useState([]);


  useEffect(() => {
    if (edit) {
      settitle(maintenancetask?.title);

      setcategory(
        maintenancetask?.hascategory[0]?.maintenancecategory?.nodeid
          ? maintenancetask?.hascategory[0]?.maintenancecategory?.nodeid
          : ""
      );
      setmaintenanceRepetition(maintenancetask?.repetitioninterval);
      setmaintenanceReminder(maintenancetask?.reminder);

      setMaintenanceDate(formatDate(maintenancetask?.startingfrom));

      setTimeout(() => {
        setmaintenanceReminder(maintenancetask.reminder);
        seterrorReminder(false);
      }, 1000);
    }
  }, [location.state]);

  useEffect(() => {
    seterrorReminder(true);
    setmaintenanceReminder("");
  }, [maintenanceRepetition]);

  const handleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    settitle(event.target.value);
  };

  const handleCategories = (event: SelectChangeEvent<string>) => {
    const selectedValue = event?.target?.value;
    setcategory(selectedValue);
  };

  const handleDate = (e: any) => {
    setMaintenanceDate(e.target.value);
  };

  const handleRepetiton = (e: any) => {
    setmaintenanceRepetition(e.target.value);
  };

  const handleReminder = (e: any) => {
    setmaintenanceReminder(e.target.value);
  };

  const receiveChildValueAttachment = (images: any, videos: any, docs: any) => {
    set_image_data(images);
    set_video_data(videos);
    set_docs_data(docs);
  };

  const handleDescription = (value: string) => {
    setDescription(value);
  };

  const navigate = useNavigate();
  const [helperTextTitle, sethelperTextTitle] = useState(
    i18n(lang)?.maintenance_title_helperText
  );

  const navigatee = useNavigate();

  const [errorTitle, seterrorTitle] = useState(false);
  const [errorCategory, seterrorCategory] = useState(false);
  const [errorReminder, seterrorReminder] = useState(false);
  const [errorRepetition, seterrorRepetition] = useState(false);
  const [helperTextDescription, sethelperTextDescription] = useState("");
  const [errorDescription, seterrorDescription] = useState(false);

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    
    if (title === "") {
      formIsValid = false;
      sethelperTextTitle("Field Cannot Empty.");
      seterrorTitle(true);
    } else {
      formIsValid = true;
      sethelperTextTitle("");
      seterrorTitle(false);
    }
    if (category === "") {
      formIsValid = false;
      seterrorCategory(true);
    } else {
      formIsValid = true;
      seterrorCategory(false);
    }


    if (maintenanceRepetition === "") {
      formIsValid = false;
      seterrorRepetition(true);
    } else {
      formIsValid = true;
      seterrorRepetition(false);
    }

    if (maintenanceReminder === "") {
      formIsValid = false;
      seterrorReminder(true);
    } else {
      formIsValid = true;
      seterrorReminder(false);
    }

    return formIsValid;
  };

  const reminderItems = getReminderItems(maintenanceRepetition, lang) as {
    key: string;
    value: string;
    label: any;
  }[];
  

  return (
    <>
      <div
        className="breadcrumpsWrapper"
        onClick={() => {
          navigatee(
            "/machine-detail?nodeid=" +
              encodeURIComponent(location.state.equipment ? location.state.equipment.nodeid : subscribedEquipments?.equipment?.nodeid) +
              "&tab=4"
          );
        }}
      >
        <div className="backIcon">
          <RoundedbackSvg />
        </div>
        <div className="breadcrumps">{i18n(lang)?.backLink}</div>
      </div>

      <section>
        
          <Paper style={{ padding: "24px" }}>
            <div className="MT_textWithIcon">
              <div>
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.99964 3.66663C5.99964 4.03482 5.70116 4.33329 5.33297 4.33329C4.96478 4.33329 4.6663 4.03482 4.6663 3.66663C4.6663 3.29844 4.96478 2.99996 5.33297 2.99996C5.70116 2.99996 5.99964 3.29844 5.99964 3.66663ZM5.50097 5.65967C5.55085 5.73468 5.59673 5.81342 5.63818 5.89573C5.92339 6.46216 5.95642 7.12263 5.72915 7.7147L5.71845 7.74257C5.65052 7.91954 5.56114 8.08751 5.45232 8.24271L4.67513 9.35116C4.43724 9.69045 3.96933 9.77265 3.63004 9.53475C3.29075 9.29686 3.20855 8.82895 3.44644 8.48966L4.22363 7.38122C4.26201 7.32647 4.29354 7.26722 4.3175 7.2048L4.3282 7.17692C4.40396 6.97957 4.39295 6.75941 4.29788 6.5706C4.12394 6.22516 3.71591 6.06853 3.3555 6.20886C3.15851 6.28556 3.00302 6.4418 2.92726 6.63915L2.91656 6.66703C2.8926 6.72945 2.87638 6.79458 2.86827 6.86095L2.70414 8.20472C2.6539 8.61604 2.27973 8.90876 1.8684 8.85852C1.45707 8.80828 1.16436 8.43411 1.2146 8.02278L1.37873 6.67901C1.40171 6.49085 1.44768 6.30622 1.51561 6.12925L1.52631 6.10138C1.75358 5.50931 2.22007 5.04059 2.81104 4.8105C3.06806 4.71042 3.33316 4.66069 3.59497 4.65694C3.42824 4.36497 3.33297 4.02692 3.33297 3.66663C3.33297 2.56206 4.2284 1.66663 5.33297 1.66663C6.05436 1.66663 6.68655 2.04856 7.03835 2.62124L11.8937 4.48868C12.1541 4.38832 12.437 4.33329 12.7327 4.33329C14.0214 4.33329 15.066 5.37796 15.066 6.66663C15.066 7.6254 14.4878 8.44912 13.661 8.80802L12.5161 12.6666H12.6663C13.4027 12.6666 13.9996 13.2636 13.9996 14C13.9996 14.7363 13.4027 15.3333 12.6663 15.3333H3.33297C2.59659 15.3333 1.99964 14.7363 1.99964 14C1.99964 13.2636 2.59659 12.6666 3.33297 12.6666H6.75251L10.7776 7.94076C10.6223 7.70281 10.5091 7.43476 10.4489 7.14725L6.14863 5.49329C5.94805 5.58299 5.72999 5.64062 5.50097 5.65967ZM13.566 6.66663C13.566 7.12686 13.1929 7.49996 12.7327 7.49996C12.2725 7.49996 11.8994 7.12686 11.8994 6.66663C11.8994 6.20639 12.2725 5.83329 12.7327 5.83329C13.1929 5.83329 13.566 6.20639 13.566 6.66663Z"
                    fill="black"
                    fillOpacity="0.5"
                  />
                </svg>
              </div>
              <div>
                
                {location.state.equipment ? location.state.equipment.name : subscribedEquipments?.equipment?.name &&
               subscribedEquipments?.equipment?.name}
              <span style={{ position: "absolute", marginLeft: "5px" }}>
                {" ("}{" "}
                { location.state.equipment ? location.state?.equipment?.hasequipmenttype &&
                  location.state?.equipment?.hasequipmenttype[0]
                    ?.equipmenttype?.isequipmenttypeof[0]?.brand?.name : subscribedEquipments?.equipment?.hasequipmenttype &&
                  subscribedEquipments?.equipment?.hasequipmenttype[0]
                    ?.equipmenttype?.isequipmenttypeof[0]?.brand?.name}

                <em style={{ marginLeft: 5 }}>
                  {location.state.equipment ?  location.state?.equipment?.hasequipmenttype &&
                    location.state?.equipment?.hasequipmenttype[0]
                      ?.equipmenttype?.model : subscribedEquipments?.equipment?.hasequipmenttype &&
                      subscribedEquipments?.equipment?.hasequipmenttype[0]
                        ?.equipmenttype?.model}
                </em>{" "}
                {")"}
              </span> 
              </div>
            </div>

            <header style={{ margin: "0px" }}>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography variant="h6">
                   

                    {i18n(lang)?.create_maintenance_task}
                  </Typography>
                </Grid>
              </Grid>
            </header>

            <div className="MT_desc">{i18n(lang)?.create_maintenance_desc}</div>



            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      onChange={handleTitle}
                      fullWidth
                      defaultValue={""}
                      label={i18n(lang)?.maintenance_title}
                      variant="outlined"
                      helperText={helperTextTitle}
                      value={title}
                      error={errorTitle || title === ""}
                      
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="maintenance_category">
                        {i18n(lang)?.maintenance_category}
                      </InputLabel>
                      <Select
                        labelId="maintenance_category"
                        id="categoryID"
                        value={category}
                        onChange={handleCategories}
                        label={i18n(lang)?.maintenance_category}
                        error={errorCategory || category === "" }
                      >
                        {dropdownMaintenanceCategory.length > 0 ? (
                          dropdownMaintenanceCategory?.map(
                            (x: any, key: number) => {
                              return (
                                <MenuItem
                                  value={x?.value}
                                  style={{
                                    margin: 10,
                                    boxSizing: "border-box",
                                    height: 24,
                                    width: "auto",
                                    border: "1px solid " + x.colorcode,
                                    borderRadius: 4,
                                    color: x.colorcode,
                                  }}
                                >
                                  {x?.title}
                                </MenuItem>
                              );
                            }
                          )
                        ) : (
                          <option></option>
                        )}
                        <Divider />
                        
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ padding: "24px 0px" }}>
                  <Grid item xs={6}>
                      <TextField
                        id="date"
                        fullWidth
                        label={i18n(lang)?.maintenance_date}
                        value={maintenanceDate}
                        defaultValue={formatDate(Date.now())}
                        onChange={handleDate}
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                       
                      />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="maintenance_repetition">
                        {i18n(lang)?.maintenance_repetition}
                      </InputLabel>
                      

                      <Select
                        labelId="maintenance_repetition"
                        onChange={handleRepetiton}
                        label={i18n(lang)?.maintenance_repetition}
                        value={maintenanceRepetition}
                         error={errorRepetition || maintenanceRepetition === ""}
                      >
                        {repetions(lang)?.length > 0 ? (
                          repetions(lang)?.map((x, key) => {
                            return (
                              <MenuItem value={x.key}>
                                {x.value} {x.label}
                              </MenuItem>
                            );
                          })
                        ) : (
                          <option></option>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="maintenance_reminder">
                        {i18n(lang)?.maintenance_reminder}
                      </InputLabel>
                      

                      <Select
                        labelId="maintenance_reminder"
                        onChange={handleReminder}
                        label={i18n(lang)?.maintenance_reminder}
                        value={maintenanceReminder}
                        error={errorRepetition || maintenanceReminder === ""}
                      >
                        {reminderItems?.length > 0 ? (
                          reminderItems.map((x:any, key:any) => {
                            return (
                              <MenuItem value={x.key}>
                                {x.value} {x.label}
                              </MenuItem>
                            );
                          })
                        ) : (
                          <option></option>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          <div style={{ margin: "52px 0px 0px 0px" }}>
            <GenericAttachment
              compTitle={i18n(lang)?.desc_planned_aintenance}
              title={title}
              startingfrom={Date.parse(maintenanceDate)}
              repetitioninterval={maintenanceRepetition}
              reminder={maintenanceReminder}
              created={Date.now()}
              categorynodeid={category}
              nodeid={subscribedEquipments?.equipment?.nodeid}
              disableSaveBtn={maintenanceReminder === "" || maintenanceRepetition === "" || category === "" || title === ""}
              noBack
              noPaperBtn
              fromMaintenance
              customSaveBtn
              customDeleteBtn
              edit={location?.state?.edit}
              maintenancetask={maintenancetask}
              errorTitle={errorTitle}
              handleValidation={handleValidation}
            />
          </div>
      </section>
    </>
  );
}
export default EditMaintenance;
